export default function formatDateString(input, withTime = false) {
  const date = new Date(input);
  if (isNaN(date)) return "";

  const options = {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...(withTime && {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
  };

  return new Intl.DateTimeFormat("en-IN", options).format(date);
}

// // Examples
// formatDateString("2026-10-07T14:30:00Z");        // "07/10/2026"
// formatDateString("2026-10-07T14:30:00Z", true);  // "07/10/2026, 8:00 pm"
// formatDateString(1791383400000, true);           // works with timestamps too

// new Date().toLocaleDateString("en-IN");                        // 07/10/2026
// new Date().toLocaleTimeString("en-IN");                        // 8:00:00 pm
// new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }); // 07/10/2026, 8:00:00 pm